"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_RATE_OVERRIDES = exports.DEFAULT_AGE_REPLACEMENT_RULES = exports.DEFAULT_RATES = void 0;
const tslib_1 = require("tslib");
const advanced_rate_overrides_json_1 = tslib_1.__importDefault(require("./advanced-rate-overrides.json"));
const homesteaders_rates_json_1 = tslib_1.__importDefault(require("./homesteaders-rates.json"));
const rules_age_json_1 = tslib_1.__importDefault(require("./rules-age.json"));
exports.DEFAULT_RATES = homesteaders_rates_json_1.default;
exports.DEFAULT_AGE_REPLACEMENT_RULES = rules_age_json_1.default;
exports.DEFAULT_RATE_OVERRIDES = advanced_rate_overrides_json_1.default;
//# sourceMappingURL=index.js.map